import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.wallet,
    (wallet) => {
        const transaction = wallet.transactions.filter(tx => {
            return ["input", "manual-in", "transfer-in", "output"].includes(tx.type) && tx.timestamp > (Date.now() - (2 * 60 * 60 * 1e3)) && tx.status === "confirmed"
        })[0] || false;

        const cashout_tx = wallet.transactions.filter(tx => {
            return ["output"].includes(tx.type) && tx.timestamp > (Date.now() - (2 * 60 * 60 * 1e3)) && ["confirmed", "pending"].includes(tx.status)
        })[0] || false;

        let tx = transaction;

        if(!transaction) {
            tx = cashout_tx;
        } else if(transaction && cashout_tx) {
            if(transaction.timestamp < cashout_tx.timestamp)
                tx = cashout_tx;
        }

        return {
            walletId: wallet.id,
            transaction: tx
        }
    }
)